import dayjs from 'dayjs';
import { localMemory } from 'localmemory';

/**
 * sleep
 * @param time
 */
export const sleep = (time: number) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(time);
    }, time);
  });
};

export const useUid = () => {
  let navigator_info = window.navigator;
  let screen_info = window.screen;
  let uid = String(navigator_info.mimeTypes.length);

  uid += navigator_info.userAgent.replace(/\D+/g, '');
  uid += navigator_info.plugins.length;
  uid += screen_info.height || '';
  uid += screen_info.width || '';
  uid += screen_info.pixelDepth || '';

  return uid;
};

/**
 * 根据某key给对象数组去重
 * @param arr
 * @param key
 * @returns
 */
export const removeDuplicates = <T>(arr: T[], key: string | string[]): T[] => {
  const isKeysArr = Array.isArray(key);

  const seen = new Set();
  return arr.filter((item: any) => {
    let targetKey = isKeysArr ? key.join('-') : key;

    const val = item[targetKey as keyof T];

    console.log('val...', val);

    if (seen.has(val + item['status'])) {
      return false;
    } else {
      seen.add(val + item['status']);
      return true;
    }
  });
};

/**
 * 根据某key给对象数组去重
 * @param arr
 * @param key
 * @returns
 */
export const removeRepeatKey = <T>(arr: T[], key: keyof T): T[] => {
  const seen = new Set();
  return arr.filter((item: any) => {
    const val = item[key];
    if (seen.has(val)) {
      return false;
    }
    seen.add(val);
    return true;
  });
};

export const fileToBase64 = (file: File): Promise<string> => {
  // console.log('filefile..', file);
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const base64String = e.target.result;
      // console.log('base64String...', base64String);
      resolve(base64String);
    };
    reader.readAsDataURL(file);
  });
};

export const base64ToFile = (base64String: string, filename?: string) => {
  const arr = base64String.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename || `screenshot-${Date.now()}.png`, { type: mime });
};

export const getFileType = (name: string) => {
  const idx = name.lastIndexOf('.');
  return name.slice(idx + 1);
};

export const getVideoSnshotFile = (blobString: string): Promise<File> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video') as HTMLVideoElement;
    video.setAttribute('autoplay', 'autoplay');
    video.setAttribute('muted', 'muted');

    const source = document.createElement('source');
    source.setAttribute('src', blobString);
    source.setAttribute('type', 'video/mp4');
    video.appendChild(source);

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    video.addEventListener('loadeddata', () => {
      // 在加载到足够的数据后尝试跳转到稍后的时间点
      if (video.readyState >= 2) {
        video.currentTime = 0.1; // 跳转到第0.1秒
      }
    });

    video.addEventListener('timeupdate', () => {
      // 当视频跳转到指定时间后
      if (video.currentTime >= 0.1) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        if (ctx) {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          const base64 = canvas.toDataURL('image/jpeg', 0.7);
          video.pause();

          const file = base64ToFile(base64);
          resolve(file);
        } else {
          reject(new Error('Canvas context is not available.'));
        }
      }
    });

    video.onerror = () => {
      reject(new Error('Failed to load video.'));
    };

    video.load();
  });
};
/**
 * Get the thumbnail of the video
 * @param base64
 * @returns
 */
export const getVideoSnapShot = async (file: File) => {
  const url = URL.createObjectURL(file);
  const imgFile = await getVideoSnshotFile(url);
  return URL.createObjectURL(imgFile);
};

/**
 * 获取当地时间/UTC时间
 * @param zone 时区
 * @param isUTC utc还是其他时区
 * @returns 时间戳
 * @tips 获取UTC时间，getLocalTime(0);
 */
export const getLocalTime = (zone: number): number => {
  const d = new Date();
  const len = d.getTime();
  if (zone === 0) {
    return len;
  }
  //本地时间与UTC时间的时间偏移差
  const offset = d.getTimezoneOffset() * 60000;
  //得到现在的UTC时间，各时区UTC时间相同
  const utcTime = len + offset;

  return new Date(utcTime + 3600000 * zone).getTime();
};

export const getZoneOffset = (): number => {
  const timezoneOffsetMinutes = new Date().getTimezoneOffset();

  const timezoneOffsetHours = -timezoneOffsetMinutes / 60;

  const formattedTimezoneOffset = (timezoneOffsetHours >= 0 ? '+' : '-') + timezoneOffsetHours;

  return +formattedTimezoneOffset;
};

export const formatTime = (utcTimestamp: number, format: string) => {
  const offset = getZoneOffset();
  // 将 UTC 时间转换为中国本地时间（UTC+8）
  const offsetTime = offset * 3600 * 1000;
  return dayjs(utcTimestamp).format(format);
};

/**
 * insert text
 * @param text
 * @returns
 */
export const insertTextAtCursor = (text: string) => {
  const selection = window.getSelection();
  if (!selection?.rangeCount) return;

  const range = selection.getRangeAt(0);
  range.deleteContents();

  let textNode = document.createTextNode(text);
  if (textNode.length > 500) {
    textNode.textContent = textNode.textContent?.slice(0, 500)!;
  }
  range.insertNode(textNode);

  range.setStartAfter(textNode);
  range.setEndAfter(textNode);
  selection.removeAllRanges();
  selection.addRange(range);
};

/**
 * Parsing address bar information
 * @param url address
 * @returns
 */
export const queryURLparams = <T>(url: string = location.href): T => {
  let obj: any = {};
  if (url.indexOf('?') < 0) return obj;
  let arr = url.split('?');

  // 去除掉第一项(baseUrl)
  const t1 = arr.filter((item, inx) => inx > 0);

  for (let j = 0, jlen = t1.length; j < jlen; j++) {
    const l = t1[j];
    const tArr = l.split('&');

    for (let i = 0; i < tArr.length; i++) {
      let arr2 = tArr[i];
      let arr3 = arr2.split('=');
      obj[arr3[0]] = decodeURIComponent(arr3[1]);
    }
  }

  return obj;
};

/**
 * clone
 * @param {*} obj clone target
 * @param {Boolean} deep deep clone
 * @returns
 */
export function clone<T>(obj: T, deep: boolean): T {
  if (Array.isArray(obj)) {
    if (deep) {
      let tempArr: any = [];
      obj.forEach((item) => {
        tempArr.push(clone(item, deep));
      });
      return tempArr as T;
    } else {
      return obj.slice() as T;
    }
  } else if (typeof obj === 'object') {
    let newObj: any = {};
    for (const key in obj) {
      if (key === 'file' || key === 'fileData') {
        newObj[key] = obj[key];
      } else if (deep) {
        newObj[key] = clone(obj[key], deep);
      } else {
        newObj[key] = obj[key];
      }
    }
    return newObj;
  } else {
    return obj;
  }
}

export const recoverArray = <T>(arr1: T[], arr2: T[], id: keyof T): T[] => {
  const combinedArray = [...arr1, ...arr2];

  const uniqueMap = new Map(combinedArray.map((item) => [item[id], item]));
  const uniqueArray = Array.from(uniqueMap.values());

  return uniqueArray;
};

export const isOpenInIFrame = (): boolean => {
  return window.self !== window.top;
};
